import { INITIAL_SALE_EVENT_CONTEXT } from "../../../constants";
import { validateSessionByCookie } from "../../services/cookies";

import { VpvRegisterEvent, VpvRegisterEventParams } from "./vpvRegister.dto";

export const handleVpvRegisterEvent = (data: VpvRegisterEventParams) => {
  const homemarket = getHm(data);
  const environment = getEnvironment(data);

  const eventData: VpvRegisterEvent = {
    event: "vpv",
    event_params: {
        page_path: data.page_path,
        page_type: data.page_type,
        micrositio: data.micrositio ?? 'loyalty',
        homemarket,
        environment,
        login: validateSessionByCookie().toString(),
    },
  };

  return eventData;
};

export const getEnvironment = (data: VpvRegisterEventParams): string => {
  return (
    JSON.parse(localStorage.getItem(INITIAL_SALE_EVENT_CONTEXT) || "{}").env ||
    (data as any).env
  );
};

export const getHm = (data) => {
  const url = data.hm;
  const hm = url.split("/")[2];

  return hm;
};
